export default __webpack_public_path__ + "static/media/stone-knight--240.a967401b.jpg";